var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 1.27734C4.70866 1.27734 1.00781 4.97819 1.00781 9.52734C1.00781 14.0765 4.70866 17.7773 9.25781 17.7773C13.807 17.7773 17.5078 14.0765 17.5078 9.52734C17.5078 4.97819 13.807 1.27734 9.25781 1.27734ZM9.25781 16.5081C5.40868 16.5081 2.27704 13.3765 2.27704 9.52734C2.27704 5.67817 5.40864 2.54657 9.25781 2.54657C13.107 2.54657 16.2386 5.67817 16.2386 9.52734C16.2386 13.3765 13.107 16.5081 9.25781 16.5081ZM13.7001 8.89273H9.89243L9.89256 3.87635C9.89256 3.52589 9.60849 3.24167 9.25787 3.24167C8.90741 3.24167 8.62319 3.52574 8.62319 3.87635V9.52734C8.62319 9.87781 8.90726 10.162 9.25787 10.162H13.7002C14.0506 10.162 14.3349 9.87796 14.3349 9.52734C14.3349 9.17688 14.0507 8.89266 13.7002 8.89266L13.7001 8.89273Z",
    fill: "#A1A7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3a9ceda3d02622946b0e488557bde7a2.svg";
export { ForwardRef as ReactComponent };